import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
// import Rectangle6 from '../../../images/adminConsole/Rectangle6.png';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    avatar: {
        width: '57px',
        borderRadius: '8px',
        // borderRadius: '100px',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        paddingTop: 20,
        paddingBottom: 20,
        height: '573px',
        overflowY: 'auto',
    },
    heading: {
        fontSize: 22,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 10,
        marginTop: 10,
        width: 700,
    },
    subHeading: {
        fontSize: 17,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 20,
    },
    arrowsBody: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 155,
        position: 'absolute',
        width: 688,
        marginLeft: 10,
    },

    contentBody: {
        paddingLeft: 50,
        paddingRight: 50,
        width: 600,
        marginTop: 100,
    },
    foQ: {
        marginTop: 40,
    },
}));

export default function SurveyResponseModal({ data }) {
    const classes = useStyles();
    const questionsLength = data?.userType === 'JS' ? 3 : 5;
    const [open, setOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleChangeQuestion = direction => {
        if (direction === 'prev') {
            if (selectedIndex !== 0) setSelectedIndex(selectedIndex - 1);
        } else {
            if (selectedIndex < questionsLength) {
                setSelectedIndex(selectedIndex + 1);
            }
        }
    };
    const handleClose = () => {
        setOpen(false);
    };
    const questionsListEmp = [
        {
            question: `Based on your usage, how helpful has "A Foot In The Door" been towards your talent sourcing needs?`,
            followQuestion: 'Can you please tell us how our platform can be more helpful towards your talent sourcing needs?',
        },
        {
            question: `How likely are you to continue using the "A Foot In The Door" platform for your talent sourcing needs?`,
            followQuestion: `Can you please tell us why you are not likely to continue using our platform for your talent sourcing needs?`,
        },
        {
            question: `Can you please tell us what feature(s) in our platform provide the most value? Please tell us why?`,
            followQuestion: ``,
        },
        {
            question: `Can you please tell us what we can do to improve the "A Foot In The Door" platform?`,
            followQuestion: ``,
        },
        {
            question: `How likely are you to recommend "A Foot In The Door" to a family member, friend, or colleague?`,
            followQuestion: `Can you please tell us why you are not likely to recommend our platform?`,
        },
        {
            question: `How satisfied are you with our level of customer support?`,
            followQuestion: `Can you please tell us why you are not completely satisfied with our customer support? How can we improve?`,
        },
    ];
    const questionsListJS = [
        {
            question: `Based on your usage, how helpful has "A Foot In The Door" been towards your job search'`,
            followQuestion: 'Can you please tell us how our platform can be more helpful towards your job search?',
        },
        {
            question: `How likely are you to continue using the "A Foot In The Door" platform for your job search needs?`,
            followQuestion: 'Can you please tell us why you are not likely to continue using our platform for your job search needs?',
        },
        {
            question: `Can you please tell us what feature(s) in our platform provide the most value? Please tell us why?`,
            followQuestion: 'Can you please tell us what we can do to improve the "A Foot In The Door" platform?',
        },
        {
            question: `How likely are you to recommend "A Foot In The Door" to a family member, friend, or colleague?`,
            followQuestion: 'Can you please tell us why you are not likely to recommend our platform?',
        },
    ];
    return (
        <div>
            <span onClick={handleOpen}>Show</span>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <div className={classes.heading}>Survey Responses</div>
                        <div className={classes.subHeading}>Submitted By : {data?.firstName + ' ' + data?.lastName}</div>
                        <div className={classes.arrowsBody}>
                            <div className={classes.arrow}>
                                <ArrowBackIosIcon onClick={() => handleChangeQuestion('prev')} role="button" />
                            </div>
                            <div className={classes.arrow}>
                                <ArrowForwardIos onClick={() => handleChangeQuestion('next')} role="button" />
                            </div>
                        </div>
                        {data?.userType === 'JS' ? (
                            <div className={classes.contentBody}>
                                {selectedIndex === 0 && (
                                    <>
                                        <p>
                                            <b>Q1.</b> <i> {questionsListJS[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A1.</b> <i>{data?.helpful}</i>{' '}
                                        </p>

                                        {data?.helpful <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ1.</b>
                                                    {questionsListJS[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA1.</b> {data?.commentMoreHelpful}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                                {selectedIndex === 1 && (
                                    <>
                                        <p>
                                            <b>Q2.</b> <i> {questionsListJS[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A2.</b> <i>{data?.continueUse}</i>{' '}
                                        </p>

                                        {data?.continueUse <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ2.</b>
                                                    {questionsListJS[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA2.</b> {data?.commentNotContinueUse}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                                {selectedIndex === 2 && (
                                    <>
                                        <p>
                                            <b>Q3.</b> <i> {questionsListJS[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A3.</b> <i>{data?.commentMostValue}</i>{' '}
                                        </p>

                                        <p className={classes.foQ}>
                                            <b>FOQ3.</b>
                                            {questionsListJS[selectedIndex]?.followQuestion}{' '}
                                        </p>
                                        <p>
                                            <b>FOA3.</b> {data?.commentImprove}{' '}
                                        </p>
                                    </>
                                )}
                                {selectedIndex === 3 && (
                                    <>
                                        <p>
                                            <b>Q4.</b> <i> {questionsListJS[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A4.</b> <i>{data?.recommend}</i>{' '}
                                        </p>

                                        {data?.recommend <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ4.</b>
                                                    {questionsListJS[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA4.</b> {data?.commentNotRecommend}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className={classes.contentBody}>
                                {selectedIndex === 0 && (
                                    <>
                                        <p>
                                            <b>Q1.</b> <i> {questionsListEmp[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A1.</b> <i>{data?.helpful}</i>{' '}
                                        </p>

                                        {data?.helpful <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ1.</b>
                                                    {questionsListEmp[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA1.</b> {data?.commentMoreHelpful}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                                {selectedIndex === 1 && (
                                    <>
                                        <p>
                                            <b>Q2.</b> <i> {questionsListEmp[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A2.</b> <i>{data?.continueUse}</i>{' '}
                                        </p>

                                        {data?.continueUse <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ2.</b>
                                                    {questionsListEmp[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA2.</b> {data?.commentNotContinueUse}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                                {selectedIndex === 2 && (
                                    <>
                                        <p>
                                            <b>Q3.</b> <i> {questionsListEmp[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A3.</b> <i>{data?.commentMostValue}</i>{' '}
                                        </p>
                                    </>
                                )}
                                {selectedIndex === 3 && (
                                    <>
                                        <p>
                                            <b>Q4.</b> <i> {questionsListEmp[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A4.</b> <i>{data?.commentImprove}</i>{' '}
                                        </p>
                                    </>
                                )}
                                {selectedIndex === 4 && (
                                    <>
                                        <p>
                                            <b>Q5.</b> <i> {questionsListEmp[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A5.</b> <i>{data?.recommend}</i>{' '}
                                        </p>

                                        {data?.recommend <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ5.</b>
                                                    {questionsListEmp[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA5.</b> {data?.commentNotRecommend}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                                {selectedIndex === 5 && (
                                    <>
                                        <p>
                                            <b>Q6.</b> <i> {questionsListEmp[selectedIndex]?.question}</i>{' '}
                                        </p>
                                        <p>
                                            <b>A6.</b> <i>{data?.custSupport}</i>{' '}
                                        </p>

                                        {data?.custSupport <= 4 && (
                                            <>
                                                <p className={classes.foQ}>
                                                    <b>FOQ6.</b>
                                                    {questionsListEmp[selectedIndex]?.followQuestion}{' '}
                                                </p>
                                                <p>
                                                    <b>FOA6.</b> {data?.commentCustSupport}{' '}
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}
